import { setErrorStatus } from '@src/api/apiClient/axiosClient';
import { Error404Provider, useError404Context } from '@src/context/Error404Context';
import { useEffect, useState } from 'react';

/**
 * APIの404エラーレスポンスを監視し、Error404Contextに反映するフック
 */
export const useError404 = () => {
  const { setNotFound, resetNotFound } = useError404Context();

  useEffect(() => {
    const handleErrorStatus = (status: number | null) => {
      if (status === 404) {
        setNotFound(true);
      } else if (status === null) {
        // エラーステータスがクリアされた場合（ページ遷移時など）
        resetNotFound();
      }
    };

    // axiosClient の errorStatusHandlers に登録
    setErrorStatus(handleErrorStatus);

    // クリーンアップ時にリセット
    return () => {
      resetNotFound();
    };
  }, [setNotFound, resetNotFound]);

  return {
    resetNotFound,
  };
};

/**
 * Error404ProviderとAPIエラー監視を組み合わせたフック
 */
export const useError404WithProvider = () => {
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    const handleErrorStatus = (status: number | null) => {
      if (status === 404) {
        setIsNotFound(true);
      } else if (status === null) {
        // エラーステータスがクリアされた場合（ページ遷移時など）
        setIsNotFound(false);
      }
    };

    // axiosClient の errorStatusHandlers に登録
    setErrorStatus(handleErrorStatus);

    // クリーンアップ時にリセット
    return () => {
      setIsNotFound(false);
    };
  }, []);

  return {
    isNotFound,
    ProviderComponent: Error404Provider,
  };
};
